(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["brand-logos-section"] && !window.DesignMode) return;
  try {
    
  $(".custom-brand-logos-wrapper").slick({
  infinite: true, 
  dots: true,
  arrows: false,
  slidesToShow: 6,
  slidesToScroll: 1,
//  centerMode: true,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
	  settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$(".custom-brand-logos .custom-carousel-advice-next").click(function(){

	$(this).parent().find(".custom-brand-logos-wrapper").slick('slickNext');
  
});
$(".custom-brand-logos .custom-carousel-advice-prev").click(function(){

	$(this).parent().find(".custom-brand-logos-wrapper").slick('slickPrev');
  
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cakemixes-carousel-mobile"] && !window.DesignMode) return;
  try {
    
  $(".custom-testimonials-wrapper-min-mobile").slick({
  infinite: false,  
  dots: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
	  settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    } 
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
  $(document).ready(function(){ 
  
      if($(window).width() < 479){ 


                  $('#desktop-video').remove();
                 $('#mobile-video').get(0).play();


        $('custom-testimonials-wrapper-min-mobile').on('afterChange', function() { 
        var dataId = $('.slick-current').attr("type");    
        if(dataId == 'video'){ 
            var video = $('.slick-current').find('video');
            video.get(0).play(); 
            $('.custom-testimonials-wrapper-min').slick('slickPause');
        }
        }); 

        $('custom-testimonials-wrapper-min-mobile').on('beforeChange', function() { 
            var dataId = $('.slick-current').attr("type");    
            if(dataId == 'video'){ 
                var video = $('.slick-current').find('video');
                video.get(0).pause(); 
                $('.custom-testimonials-wrapper-min').slick('slickPlay');
            }
        }); 


      }
                              
    });  
  
$(".custom-testimonials .custom-carousel-advice-next").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper-min-mobile").slick('slickNext');
  
});
$(".custom-testimonials .custom-carousel-advice-prev").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper-min-mobile").slick('slickPrev');
  
});
  
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cakemixes-carousel"] && !window.DesignMode) return;
  try {
    
  $(".custom-testimonials-wrapper-min").slick({ 
  infinite: false,  
  dots: true, 
  arrows: false,
  slidesToShow: 1, 
  slidesToScroll: 1,
  pauseOnHover:true, 
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true 
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
	  settings: {
        slidesToShow: 1, 
        slidesToScroll: 1 
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object 
  ]
});
  
  $(document).ready(function(){ 
  
  if($(window).width() > 479){   
  
  	$('#mobile-video').remove();
  
    $('#desktop-video').get(0).play();


    $('.custom-testimonials-wrapper-min').on('afterChange', function() { 
      var dataId = $('.slick-current').attr("type");    
      if(dataId == 'video'){ 
          var video = $('.slick-current').find('video');
          video.get(0).play(); 
          $('.custom-testimonials-wrapper-min').slick('slickPause');
      }
    }); 
  
	}
  
});
  
$(".custom-testimonials .custom-carousel-advice-next").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper-min").slick('slickNext');
  
});
$(".custom-testimonials .custom-carousel-advice-prev").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper-min").slick('slickPrev');
  
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-card-slider-section"] && !window.DesignMode) return;
  try {
    
$(".custom-card-slideshow-wrapper").slick({
infinite: true,
arrows: false,
dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-category-slider-section"] && !window.DesignMode) return;
  try {
    
  $(".custom-category-slideshow-wrapper").slick({
	infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
	asNavFor: '.custom-category-text-slideshow-wrapper'
  });
	$(".custom-category-text-slideshow-wrapper").slick({
    infinite: true,
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
	asNavFor: '.custom-category-slideshow-wrapper'
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !window.DesignMode) return;
  try {
    
  $(".custom-testimonials-wrapper").slick({
  infinite: true, 
  dots: true,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
	  settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$(".custom-testimonials .custom-carousel-advice-next").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper").slick('slickNext');
  
});
$(".custom-testimonials .custom-carousel-advice-prev").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper").slick('slickPrev');
  
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-testimonials"] && !window.DesignMode) return;
  try {
    
  $(".custom-testimonials-wrapper").slick({
  infinite: true, 
  dots: true,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
	  settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$(".custom-testimonials .custom-carousel-advice-next").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper").slick('slickNext');
  
});
$(".custom-testimonials .custom-carousel-advice-prev").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper").slick('slickPrev');
  
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-category"] && !window.DesignMode) return;
  try {
    
$('.one-time').slick({
	infinite: false,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
	arrows: true,
	nextArrow:'.btn--plain-next',
	prevArrow:'.btn--plain-prev',
    dots: true,
    customPaging: function(slider, i) {
	console.log(i); 
return '<div><span>' + $(slider.$slides[i]).attr('title') + '</span><div class="active-div"></div></div>'; 
        }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-landing-testimonials"] && !window.DesignMode) return;
  try {
    
  $(".custom-testimonials-wrapper").slick({
  infinite: true, 
  dots: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1
});
  
$(".custom-testimonials .custom-carousel-advice-next").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper").slick('slickNext');
  
});
$(".custom-testimonials .custom-carousel-advice-prev").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper").slick('slickPrev');
  
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-pick-by-age"] && !window.DesignMode) return;
  try {
    
$('.mobile-pick-by-age-slider').slick({
    dots: true,
    infinite: false, 
    speed: 300,
    slidesToShow: 1, 
    adaptiveHeight: true,
	arrows: true,
	nextArrow:'.btn-next-1',
	prevArrow:'.btn-prev-1',
	customPaging: function(slider, i) { 
	var cons = $(slider.$slides[i]).attr('title')+'-sub';  
return '<div class="tab-div"> <span class="tab">' + $(slider.$slides[i]).attr('title') + '</span><div class="act-div"> </div></div><ul  class="'+$(slider.$slides[i]).attr('title')+' '+' tab-ul">'+$('.'+cons.replace(/\s/g,'')).html()+'</ul>';
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-testimonials"] && !window.DesignMode) return;
  try {
    
  $(".custom-testimonials-wrapper").slick({
  infinite: true, 
  dots: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1
});
$(".custom-testimonials .custom-carousel-advice-next").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper").slick('slickNext');
  
});
$(".custom-testimonials .custom-carousel-advice-prev").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper").slick('slickPrev');
  
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-community-template"]) return;
  try {
    
  $(document).load(function(){

    var highestBox = 0;
        $('.person-wrapper .inner-wrapper').each(function(){  
                if($(this).height() > highestBox){  
                highestBox = $(this).height();  
		console.log(highestBox) 
        }
    });    
    $('.person-wrapper .inner-wrapper').height(highestBox);

});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !window.DesignMode) return;
  try {
    
  $(".custom-product-collection").slick({
  infinite: false, 
  dots: true,
  arrows: false,
  slidesToShow: 23,
  slidesToScroll: 1,
  centerPadding: $('.slick').find('.p-slide').outerWidth() / 2, 
  centerMode: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true 
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
		slidesToScroll: 1,
      }
    }
  ]
});
$(window).on('load', function() {
   	$('.js-featured-collection-slider .slick-track').css('transform','translate3d(0px, 0px, 0px)');
	console.log('kjgjkgk');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-nocart"]) return;
  try {
    
$(".product-detail-carousel-peek__advice").click(function(){

	$(this).animate({'right': '50', 'opacity': 0});;
	$(this).parent().find(".slick-initialized").slick('slickNext');
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
$(".product-detail-carousel-peek__advice").click(function(){

	$(this).animate({'right': '50', 'opacity': 0});;
	$(this).parent().find(".slick-initialized").slick('slickNext');
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slide-newimagediwali-section"] && !window.DesignMode) return;
  try {
    
$(".custom-slideshow").height(window.innerHeight+100);
 $(".custom-slide").height(window.innerHeight+100);
 $(".custom-slide-image").height(window.innerHeight+100);
  $('.custom-slideshow-wrapper').slick({
	infinite: true, 
	dots: true,
	arrows: false,
    fade: true,
    arrows: false,
	dots: true

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-custom-section"] && !window.DesignMode) return;
  try {
    
$(".custom-slideshow").height(window.innerHeight+100);
 $(".custom-slide").height(window.innerHeight+100);
 $(".custom-slide-image").height(window.innerHeight+100);
  $('.custom-slideshow-wrapper').slick({
	infinite: true, 
	dots: true,
	arrows: false,
    fade: true,
    arrows: false,
	dots: true

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-newdiwali-section"] && !window.DesignMode) return;
  try {
    
$(".custom-slideshow").height(window.innerHeight+100);
 $(".custom-slide").height(window.innerHeight+100);
 $(".custom-slide-image").height(window.innerHeight+100);
  $('.custom-slideshow-wrapper').slick({
	infinite: true, 
	dots: true,
	arrows: false,
    fade: true,
    arrows: false,
	dots: true

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-section"] && !window.DesignMode) return;
  try {
    
  $(".custom-testimonials-wrapper").slick({
  infinite: true, 
  dots: true,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
	  settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$(".custom-testimonials .custom-carousel-advice-next").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper").slick('slickNext');
  
});
$(".custom-testimonials .custom-carousel-advice-prev").click(function(){

	$(this).parent().find(".custom-testimonials-wrapper").slick('slickPrev');
  
});
  
  } catch(e) { console.error(e); }
})();

})();
